import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const CategoryFocusBox = styled.div``

export const FocusNews = styled.div`
    display: flex;

    @media screen and (max-width: 767px) {
        flex-direction: column;
    }
`

export const FocusNewsImageLink = styled(Link)`
    text-decoration: none;
    display: block;
`

export const FocusNewsImage = styled.img`
    width: 324px;
    height: 202px;

    @media screen and (max-width: 767px) {
        width: 100%;
        height: 243px;
    }

    @media screen and (max-width: 374px) {
        height: 185px;
    }
`

export const FocusNewsBody = styled.div`
    margin-left: 10px;
    flex: 1;
`

export const FocusNewsCategory = styled(Link)`
    color: #8F8F8F;
    font-size: 10px;
    text-transform: uppercase;
    text-decoration: none;
    display: block;
`

export const FocusNewsTitle = styled(Link)`
    text-decoration: none;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
    color: #353535;
    font-size: 20px;
    line-height: 1.1;
    margin-top: 6px;
    font-weight: 500;

    @media screen and (max-width: 767px) {
        color: #333;
        font-weight: 700;
        -webkit-line-clamp: 3;
    }

    @media screen and (max-width: 374px) {
        font-size: 18px;
        line-height: 1.3;
    }
`

export const FocusNewsDesc = styled.p`
    color: #222;
    font-size: 12px;
    line-height: 1.17;
    margin-top: 12px;
    opacity: .7;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;

    @media screen and (max-width: 767px) {
        font-size: 13px;
        line-height: 1.4;
    }
`

export const FocusNewsRelative = styled.div`
    margin-top: 16px;
`

export const FocusNewsLink = styled(Link)`
    text-decoration: none;
    color: #353535;
    font-size: 13px;
    font-weight: 500;
    margin-left: 8px;
    margin-top: 5px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;

    
`

export const RelativeWrap = styled.h3`
    position: relative;

    &:before {
        width: 4px;
        height: 4px;
        border-radius: 3px;
        background-color: #006ba8;
        content: '';
        display: block;
        left: 0px;
        position: absolute;
        top: 4px;
    }
`

export const CategoryFocusList = styled.ul`
    width: 100%;
    list-style: none;
    display: flex;
`

export const CategoryFocusItem = styled.li`
    @media screen and (max-width: 767px) {
        display: flex;
    }

    @media screen and (max-width: 475px) {
        margin-bottom: 3px;
        padding-bottom: 5px;
        border-bottom: 1px solid #d8d8d8;
    }
`

export const CategoryFocusImageLink = styled(Link)`
    text-decoration: none;
    display: block;
`

export const CategoryFocusImage = styled.img`
    height: 77px;
    width: 100%;

    @media screen and (max-width: 767px) {
        width: 165px;
        height: 103px;
    }

    @media screen and (max-width: 374px) {
        width: 128px;
        height: 80px;
    }
`

export const CategoryFocusTitle = styled(Link)`
    text-decoration: none;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
    margin-top: 6px;
    color: #222;
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 4px;

    @media screen and (max-width: 767px) {
        margin-left: 10px;
        font-size: 18px;
        -webkit-line-clamp: 4;
        font-weight: 500;
        align-self: flex-start;
    }

    @media screen and (max-width: 374px) {
        font-size: 16px;
        margin-top: 0;
    }
`